/* eslint-disable no-use-before-define */
'use strict';
const PRODUCT_OPTION_ID_GIFTPACKAGE = 'giftPackage';

function inputHandler(event, dataPackageId, divSelector) {
    event.preventDefault();
    const options = getSelectOptionsIdsAndValues(divSelector);
    const optionToChange = getOptionToChange(dataPackageId, options);
    simulateSelectElementChangeEvent(divSelector, optionToChange.value);
}

function getOptionToChange(optionId, options) {
    return options.find(option => option.optionId.toString() === optionId.toString());
}

function simulateSelectElementChangeEvent(selector, newValue) {
    $(selector) // Query the div that wraps the <select> element
        .find('select.options-select') // Gets the select element
        .val(newValue) // Updates the option selected with the corresponding value
        .trigger('change'); // Fires the event 'change' in order to call the corresponding handler.
}

function getSelectOptionsIdsAndValues(selector) {
    /* .options-select is standard class from SFRA.
    We wrap the <select></select> element inside a <div></div>
    which is query by the 'selector' param */
    const options = $(selector).find('select.options-select option');

    return $.map(options, function (option) {
        return {
            // We get the id that is stored in the ISML attribute data-value-id
            optionId: option.dataset.valueId,

            // The value attribute contains the URL to request for a option change
            value: option.value,

            // We also get useful prices values, added by customization on data attributes
            price: option.dataset.price,
            priceValue: Number(option.dataset.priceValue)
        };
    });
}

module.exports = {
    reset: function () {
        $(document).on('click', 'li[class*="variation-attribute-size"], div[class*="variation-attribute-size-values"]', function (e) {
            if ($('#giftpackage-collapsibles').hasClass('show')) {
                $('#giftpackage-collapsibles').collapse('toggle');
                $('#add-giftpackage').removeClass('expanded').addClass('not-expanded');
                $('#remove-giftpackage').removeClass('not-expanded').addClass('expanded');
            }
        });
    },
    addrGiftpackage: function () {
        $('body').on('click', '#add-giftpackage', function (e) {
            const dataPackageId = $('.product-giftpackage-summary-total-id').text().trim();
            inputHandler(e, dataPackageId, `[data-option-id="${PRODUCT_OPTION_ID_GIFTPACKAGE}"]`);
        });
    },
    removeGiftpackage: function () {
        $('body').on('click', '#remove-giftpackage', function (e) {
            const dataPackageId = $('.product-giftpackage-null-total-id').text().trim();
            inputHandler(e, dataPackageId, `[data-option-id="${PRODUCT_OPTION_ID_GIFTPACKAGE}"]`);
        });
    }
};
